export const validateState = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const stateNonce = searchParams.get('state');
    const code = searchParams.get('code');
    if (stateNonce && localStorage.getItem(stateNonce)) {
        const redirectPath = localStorage.getItem(stateNonce);
        localStorage.removeItem(stateNonce);
        return redirectPath;
    }
    else if (code && !stateNonce) {
        location.reload();
    }
};
